import { render, staticRenderFns } from "./Customer_assignment.vue?vue&type=template&id=7df72ca0&"
import script from "./Customer_assignment.vue?vue&type=script&lang=js&"
export * from "./Customer_assignment.vue?vue&type=script&lang=js&"
import style0 from "./Customer_assignment.vue?vue&type=style&index=0&id=7df72ca0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports